import { useEffect, useState } from 'react';
import { FaStar, FaShieldAlt, FaFileContract, FaGlobe, FaCheckCircle, FaRegClock, FaMagnifyingGlass, FaArrowRight, FaLightbulb, FaGavel, FaChartLine, FaClock, FaUsers, FaAward, FaLock } from "react-icons/fa";
import { Link } from 'react-router-dom';
import LazyImg from '../../components/LazyImg';
import Meta from '../../components/Meta';
import Faq from '../../components/Faq';
import Testimonial from '../../components/Testimonial';
import headerImg from "../../assets/images/headerImg.png";
import RotatingCircle from '../../components/RotatingCircle/RotatingCircle';

export default function TrademarkBody() {
  const [responsive, setResponsive] = useState(false);
  const [entity, setEntity] = useState('');
  const [state, setState] = useState('');

  useEffect(() => {
    const onResize = () => setResponsive(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const fontSize = (big, small) => (responsive ? small : big);
  const getResponsiveFont = fontSize; // For compatibility with pasted code

  const handleEntityChange = (e) => setEntity(e.target.value);
  const handleStateChange = (e) => setState(e.target.value);

  const faqItems = [
    {
      title: 'What is a Trademark?',
      content: <p>A trademark is a distinctive sign, logo, or symbol that identifies your goods or services and legally protects your brand identity.</p>
    },
    {
      title: 'Who can register a trademark in Bangladesh?',
      content: <p>Both Bangladeshi residents and foreign entities can apply for trademark registration in Bangladesh.</p>
    },
    {
      title: 'How long does the registration process take?',
      content: <p>The entire process usually takes 12 to 18 months depending on government procedures and oppositions, if any.</p>
    },
    {
      title: 'Can I trademark a logo and a brand name?',
      content: <p>Yes, you can register words, logos, slogans, shapes, and combinations thereof as trademarks.</p>
    }
  ];

  return (
    <main style={{ maxWidth: "100%", backgroundColor: "#ffffff" }}>
      <Meta
        title="Trademark Registration in Bangladesh | JK Associates"
        description="Protect your brand with expert Trademark Registration services in Bangladesh. JK Associates guides you through the entire legal process seamlessly."
        keywords="Trademark Registration Bangladesh, Intellectual Property, Brand Protection, Trademark Lawyer Bangladesh"
      />


      {/* Hero Section */}
      <section className='heroSection'>
        <div className='r-container'>
          <div style={{ justifyContent: "space-between" }} className='row row-cols-lg-2 row-cols-1 align-items-center'>
            <div className='d-flex flex-column gap-4 pe-lg-5 m-margin-top-1 z-0'>
              <span style={{ color: "#ff6b35", fontSize: getResponsiveFont("18px", "14px") }} className="font-2 m-text-center m-text-sm">
                Welcome to JK Associates Group
              </span>
              <Link className='m-d-none' target='_blank' to="https://www.google.com/maps/place/JK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark/@23.7927683,90.3719291,17z/data=!4m16!1m9!3m8!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!2sJK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark!8m2!3d23.7927683!4d90.374504!9m1!1b1!16s%2Fg%2F11c54h2yxw!3m5!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!8m2!3d23.7927683!4d90.374504!16s%2Fg%2F11c54h2yxw?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D">
                <span className='home-top bg-secondary opacity-75 p-2' style={{ fontSize: getResponsiveFont("16px", "12px") }}>
                  Excellent 5 out of 5&nbsp;
                  <FaStar style={{ color: "yellow", marginBottom: "5px" }} /> Google
                </span>
              </Link>
              <h1 style={{ marginBottom: "0", fontSize: getResponsiveFont("40px", "24px"), textAlign: "center" }}>
                Trademark Your Brand
              </h1>
              <p style={{ textAlign: 'justify', fontSize: getResponsiveFont("16px", "12px") }}>
                From anywhere in the world, our complete platform simplifies the Bangladesh company registration,
                allowing you to establish your business​. JK Associates" company formation for non-Bangladesh residents.
                Easily start a Bangladesh business, online.
              </p>
              {/* Trademark Registration Form */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: responsive ? '14px' : '18px',
                marginTop: responsive ? '16px' : '20px'
              }}>
                {/* Brand Name Input */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px'
                }}>
                  <label style={{
                    fontSize: fontSize('13px', '11px'),
                    fontWeight: 600,
                    color: '#2f5d32',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    What's Your Brand Name? *
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your brand name or trademark"
                    style={{
                      padding: responsive ? '10px 14px' : '12px 16px',
                      fontSize: fontSize('15px', '13px'),
                      border: '2px solid #e0e0e0',
                      borderRadius: '8px',
                      fontFamily: 'inherit',
                      transition: 'all 0.3s ease',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#ff6b35';
                      e.target.style.boxShadow = '0 0 0 3px rgba(255,107,53,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e0e0e0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                {/* Classification & Division */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
                  gap: responsive ? '12px' : '16px'
                }}>
                  {/* Goods/Services Type */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px'
                  }}>
                    <label style={{
                      fontSize: fontSize('13px', '11px'),
                      fontWeight: 600,
                      color: '#2f5d32',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Type of Mark *
                    </label>
                    <select
                      value={entity}
                      onChange={handleEntityChange}
                      style={{
                        padding: responsive ? '10px 14px' : '12px 16px',
                        fontSize: fontSize('15px', '13px'),
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px',
                        fontFamily: 'inherit',
                        transition: 'all 0.3s ease',
                        backgroundColor: 'white',
                        cursor: 'pointer',
                        appearance: 'none',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234caf50' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 10px center',
                        paddingRight: responsive ? '28px' : '32px'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6b35';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255,107,53,0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <option value="">Select Type of Mark</option>
                      <option value="Word Mark">Word Mark (Brand Name)</option>
                      <option value="Logo/Symbol">Logo/Symbol</option>
                      <option value="Combined Mark">Combined Mark (Word + Logo)</option>
                      <option value="Service Mark">Service Mark</option>
                    </select>
                  </div>

                  {/* Location/Division */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px'
                  }}>
                    <label style={{
                      fontSize: fontSize('13px', '11px'),
                      fontWeight: 600,
                      color: '#2f5d32',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Your Location *
                    </label>
                    <select
                      value={state}
                      onChange={handleStateChange}
                      style={{
                        padding: responsive ? '10px 14px' : '12px 16px',
                        fontSize: fontSize('15px', '13px'),
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px',
                        fontFamily: 'inherit',
                        transition: 'all 0.3s ease',
                        backgroundColor: 'white',
                        cursor: 'pointer',
                        appearance: 'none',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234caf50' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 10px center',
                        paddingRight: responsive ? '28px' : '32px'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6b35';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255,107,53,0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <option value="">Select Division</option>
                      <option value="Dhaka">Dhaka</option>
                      <option value="Chittagong">Chittagong</option>
                      <option value="Khulna">Khulna</option>
                      <option value="Rajshahi">Rajshahi</option>
                      <option value="Sylhet">Sylhet</option>
                      <option value="Rangpur">Rangpur</option>
                    </select>
                  </div>
                </div>

                {/* Info Text */}
                <div style={{
                  backgroundColor: 'rgba(255,107,53,0.08)',
                  border: '1px solid rgba(255,107,53,0.2)',
                  borderRadius: '8px',
                  padding: responsive ? '10px 12px' : '12px 14px',
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'flex-start'
                }}>
                  <span style={{ fontSize: '16px', flexShrink: 0 }}>ℹ️</span>
                  <p style={{
                    fontSize: fontSize('12px', '11px'),
                    color: '#2f5d32',
                    margin: 0,
                    lineHeight: 1.4
                  }}>
                    Protect your brand in all classes. Our experts will guide you through the entire registration process.
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              {(entity && state) && (
                <button
                  style={{
                    marginTop: responsive ? '18px' : '24px',
                    width: '100%',
                    padding: responsive ? '12px 20px' : '14px 32px',
                    fontSize: fontSize('16px', '13px'),
                    fontWeight: 700,
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 20px rgba(255,107,53,0.25)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                  onClick={() => {
                    window.open("https://api.whatsapp.com/send/?phone=01511404971&text=I%20would%20like%20to%20register%20a%20trademark%3A%20" + encodeURIComponent(entity + " - " + state), "_blank");
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#45a049';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 28px rgba(255,107,53,0.35)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ff6b35';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(255,107,53,0.25)';
                  }}
                >
                  <span>Start Trademark Registration</span>
                  <span style={{ fontSize: '14px' }}>→</span>
                </button>
              )}

            </div>
            {/* header right side img */}
            <RotatingCircle />
          </div>
        </div>
      </section>
      {/* header end  */}

      {/* How it Works - Trademark Searches & Registration */}
      <section style={{
        backgroundColor: '#ffffff',
        padding: responsive ? '30px 15px' : '60px 40px',
        maxWidth: '100%',
        margin: 'auto',
        overflow: 'hidden'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Section Header */}
          <div style={{ textAlign: 'center', marginBottom: responsive ? '40px' : '60px' }}>
            <h2 style={{
              fontSize: responsive ? '28px' : '42px',
              fontWeight: 800,
              color: '#1a1a1a',
              margin: '0 0 16px 0',
              lineHeight: 1.2
            }}>
              Trademark Searches & Registration:
            </h2>
            <p style={{
              fontSize: responsive ? '18px' : '24px',
              fontWeight: 600,
              color: '#1a1a1a',
              margin: 0
            }}>
              How it Works
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: responsive ? '30px' : '60px',
            alignItems: 'center'
          }}>
            {/* Left Side - Steps */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: responsive ? '24px' : '32px'
            }}>
              {/* Step 1 */}
              <div style={{
                display: 'flex',
                gap: responsive ? '16px' : '24px',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: responsive ? '48px' : '60px',
                  height: responsive ? '48px' : '60px',
                  backgroundColor: '#f5e6d3',
                  borderRadius: '8px',
                  flexShrink: 0,
                  fontSize: responsive ? '24px' : '32px'
                }}>
                  🔍
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{
                    fontSize: responsive ? '16px' : '18px',
                    fontWeight: 700,
                    color: '#1a1a1a',
                    margin: '0 0 8px 0'
                  }}>
                    Tell us what you need
                  </h3>
                  <p style={{
                    fontSize: responsive ? '13px' : '15px',
                    color: '#555',
                    margin: 0,
                    lineHeight: 1.6
                  }}>
                    Share your brand name, logo, or description of what you want to trademark.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div style={{
                display: 'flex',
                gap: responsive ? '16px' : '24px',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: responsive ? '48px' : '60px',
                  height: responsive ? '48px' : '60px',
                  backgroundColor: '#f5e6d3',
                  borderRadius: '8px',
                  flexShrink: 0,
                  fontSize: responsive ? '24px' : '32px'
                }}>
                  🔎
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{
                    fontSize: responsive ? '16px' : '18px',
                    fontWeight: 700,
                    color: '#1a1a1a',
                    margin: '0 0 8px 0'
                  }}>
                    We get to work
                  </h3>
                  <p style={{
                    fontSize: responsive ? '13px' : '15px',
                    color: '#555',
                    margin: 0,
                    lineHeight: 1.6
                  }}>
                    The trademark attorney will conduct a trademark search to ensure the availability, then provide the search results along with a plan of action.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div style={{
                display: 'flex',
                gap: responsive ? '16px' : '24px',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: responsive ? '48px' : '60px',
                  height: responsive ? '48px' : '60px',
                  backgroundColor: '#f5e6d3',
                  borderRadius: '8px',
                  flexShrink: 0,
                  fontSize: responsive ? '24px' : '32px'
                }}>
                  📋
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{
                    fontSize: responsive ? '16px' : '18px',
                    fontWeight: 700,
                    color: '#1a1a1a',
                    margin: '0 0 8px 0'
                  }}>
                    We will file your trademark with the Patent and Trademark office
                  </h3>
                  <p style={{
                    fontSize: responsive ? '13px' : '15px',
                    color: '#555',
                    margin: 0,
                    lineHeight: 1.6
                  }}>
                    The attorney will file the trademark with the Department of Patents, Designs and Trademarks (DPDT) and deliver the approved trademark documentation.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side - Phone Mockup / Visual */}
            <div style={{
              display: responsive ? 'none' : 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, #f5f5f5, #fafafa)',
                borderRadius: '20px',
                padding: '30px',
                textAlign: 'center',
                maxWidth: '350px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                position: 'relative'
              }}>
                {/* Phone frame simulation */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '16px',
                  padding: '20px',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                }}>
                  <div style={{
                    backgroundColor: '#f9f9f9',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '16px',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '60px',
                      height: '60px',
                      backgroundColor: '#ff6b35',
                      borderRadius: '12px',
                      margin: '0 auto 12px',
                      fontSize: '32px',
                      color: 'white'
                    }}>
                      ✓
                    </div>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: 700,
                      color: '#1a1a1a',
                      margin: '0 0 8px 0'
                    }}>
                      Trademark Protection is Active!
                    </h4>
                    <p style={{
                      fontSize: '12px',
                      color: '#666',
                      margin: '0 0 16px 0',
                      lineHeight: 1.5
                    }}>
                      Your brand is now legally protected against unauthorized use and counterfeiting.
                    </p>
                  </div>

                  {/* Info items */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    marginTop: '16px'
                  }}>
                    {[
                      { label: 'Trademark Size', value: '320x x 320' },
                      { label: 'Order Status', value: 'Completed' },
                      { label: 'Payment Method', value: 'Visa' },
                      { label: 'Purchase Date', value: 'May 31, 2025' }
                    ].map((item, i) => (
                      <div key={i} style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingBottom: i < 3 ? '12px' : 0,
                        borderBottom: i < 3 ? '1px solid #e0e0e0' : 'none',
                        fontSize: '12px'
                      }}>
                        <span style={{ color: '#999' }}>{item.label}</span>
                        <span style={{ color: '#1a1a1a', fontWeight: 600 }}>{item.value}</span>
                      </div>
                    ))}
                  </div>

                  <button style={{
                    width: '100%',
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    fontSize: '14px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    marginTop: '16px',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#e55a28';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#ff6b35';
                    }}>
                    Download Certificate
                  </button>
                </div>

                {/* Floating badge */}
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#ff6b35',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '20px',
                  boxShadow: '0 4px 12px rgba(255,107,53,0.4)'
                }}>
                  ✓
                </div>
              </div>
            </div>
          </div>

          {/* Info Banner */}
          <div style={{
            marginTop: responsive ? '30px' : '50px',
            backgroundColor: '#f5e6d3',
            borderLeft: '4px solid #ff6b35',
            padding: responsive ? '16px' : '20px',
            borderRadius: '8px',
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start'
          }}>
            <span style={{ fontSize: '20px', flexShrink: 0 }}>💬</span>
            <div>
              <p style={{
                fontSize: responsive ? '13px' : '14px',
                color: '#333',
                margin: 0,
                lineHeight: 1.6,
                fontWeight: 500
              }}>
                <strong>What makes us different? 5 major benefits that set us apart.</strong>&nbsp;
                <a href="#benefits" style={{
                  color: '#ff6b35',
                  textDecoration: 'none',
                  fontWeight: 700,
                  cursor: 'pointer'
                }}>
                  Learn More →
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* How it Works end */}

      {/* Hero Banner */}
      <section style={{
        backgroundColor: '#ff6b35',
        color: 'white',
        padding: responsive ? '20px 12px' : '60px 40px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: fontSize('42px', '20px'),
          marginBottom: '15px',
          lineHeight: 1.2
        }}>
          Trademark Registration in Bangladesh
        </h1>
        <p style={{
          fontSize: fontSize('18px', '13px'),
          maxWidth: '100%',
          margin: '0 auto',
          padding: responsive ? '0 5px' : '0',
          lineHeight: 1.5
        }}>
          Secure your brand identity and legal rights with professional Trademark Registration services from JK Associates. Trusted by entrepreneurs nationwide.
        </p>
      </section>

      {/* Legal Framework */}
      <section style={{
        padding: responsive ? '20px 15px' : '50px 40px',
        maxWidth: '100%',
        margin: 'auto',
        overflow: 'hidden'
      }}>
        <h2 style={{
          fontSize: fontSize('28px', '18px'),
          color: '#2f5d32',
          marginBottom: '20px',
          textAlign: 'center'
        }}>Legal Framework in Bangladesh</h2>
        <p style={{
          fontSize: fontSize('16px', '13px'),
          lineHeight: 1.6,
          padding: responsive ? '0 5px' : '0'
        }}>
          Trademark registration in Bangladesh is governed by the <b>Trademarks Act 2009</b> and overseen by the Department of Patents, Designs and Trademarks (DPDT). JK Associates ensures your application complies with all legal requirements for a smooth registration process.
        </p>
      </section>

      {/* Benefits */}
      <section style={{
        backgroundColor: 'white',
        padding: responsive ? '20px 15px' : '50px 40px',
        maxWidth: '100%',
        margin: 'auto',
        overflow: 'hidden'
      }}>
        <h2 style={{
          fontSize: fontSize('28px', '18px'),
          color: '#ff6b35',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          Benefits of Trademark Registration
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
          gap: responsive ? '20px' : '30px',
          textAlign: 'center',
          color: '#2f5d32'
        }}>
          {[{
            icon: <FaShieldAlt size={responsive ? 35 : 50} color="#ff6b35" />,
            title: 'Legal Protection',
            desc: 'Exclusive rights to your brand preventing unauthorized use.'
          }, {
            icon: <FaFileContract size={responsive ? 35 : 50} color="#ff6b35" />,
            title: 'Asset Value',
            desc: 'Enhances your brand value as an intangible business asset.'
          }, {
            icon: <FaStar size={responsive ? 35 : 50} color="#ff6b35" />,
            title: 'Brand Identity',
            desc: 'Helps customers identify and trust your products or services.'
          }].map(({ icon, title, desc }, i) => (
            <div key={i} style={{
              padding: responsive ? '15px 10px' : '20px',
              borderRadius: '8px',
              transition: 'transform 0.3s'
            }}>
              <div style={{ marginBottom: '10px' }}>{icon}</div>
              <h3 style={{
                fontSize: fontSize('20px', '15px'),
                marginTop: '10px',
                marginBottom: '8px'
              }}>{title}</h3>
              <p style={{
                fontSize: fontSize('14px', '12px'),
                lineHeight: 1.5,
                margin: 0
              }}>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* What Can Be Trademarked */}
      <section style={{
        padding: responsive ? '20px 15px' : '50px 40px',
        maxWidth: '100%',
        margin: 'auto',
        overflow: 'hidden',
        backgroundColor: '#f9f9f9'
      }}>
        <h2 style={{
          fontSize: fontSize('28px', '18px'),
          color: '#ff6b35',
          marginBottom: '40px',
          textAlign: 'center',
          fontWeight: 'bold'
        }}>
          What Can Be Trademarked?
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: responsive ? '1fr' : 'repeat(2, 1fr)',
          gap: responsive ? '20px' : '30px',
          maxWidth: responsive ? '100%' : '1000px',
          margin: '0 auto'
        }}>
          {[
            {
              icon: <FaFileContract size={responsive ? 35 : 45} color="#ff6b35" />,
              title: 'Words or Brand Names',
              desc: 'Protect your unique brand name, slogan, or distinctive words.'
            },
            {
              icon: <FaGlobe size={responsive ? 35 : 45} color="#ff6b35" />,
              title: 'Logos and Symbols',
              desc: 'Register your company logo, symbols, or graphical designs.'
            },
            {
              icon: <FaStar size={responsive ? 35 : 45} color="#ff6b35" />,
              title: 'Slogans and Taglines',
              desc: 'Secure catchy phrases and memorable marketing slogans.'
            },
            {
              icon: <FaCheckCircle size={responsive ? 35 : 45} color="#ff6b35" />,
              title: 'Shapes and Packaging',
              desc: 'Protect distinctive product shapes and packaging designs.'
            },
            {
              icon: <FaShieldAlt size={responsive ? 35 : 45} color="#ff6b35" />,
              title: 'Service Marks',
              desc: 'Register marks for services rather than physical goods.'
            },
            {
              icon: <FaCheckCircle size={responsive ? 35 : 45} color="#ff6b35" />,
              title: 'Combined Elements',
              desc: 'Register combinations of words, logos, colors, and sounds.'
            }
          ].map(({ icon, title, desc }, i) => (
            <div
              key={i}
              style={{
                padding: responsive ? '20px 15px' : '25px',
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '2px solid #e0f2e0',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(255,107,53,0.1)',
                cursor: 'pointer',
                ':hover': {
                  boxShadow: '0 8px 16px rgba(255,107,53,0.2)',
                  transform: 'translateY(-5px)'
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(255,107,53,0.2)';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(255,107,53,0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: responsive ? '50px' : '60px',
                  height: responsive ? '50px' : '60px',
                  borderRadius: '10px',
                  backgroundColor: '#e8f5e9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  {icon}
                </div>
                <h3 style={{
                  fontSize: fontSize('18px', '14px'),
                  color: '#2f5d32',
                  margin: 0,
                  fontWeight: '600'
                }}>
                  {title}
                </h3>
              </div>
              <p style={{
                fontSize: fontSize('14px', '12px'),
                color: '#555',
                lineHeight: 1.6,
                margin: 0,
                paddingLeft: responsive ? '0' : '75px'
              }}>
                {desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Process */}
      <section style={{
        backgroundColor: 'white',
        padding: responsive ? '20px 15px' : '50px 40px',
        maxWidth: '100%',
        margin: 'auto',
        marginTop: responsive ? '20px' : '40px',
        overflow: 'hidden'
      }}>
        <h2 style={{
          fontSize: fontSize('36px', '18px'),
          color: '#ff6b35',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          Trademark Registration Process
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: responsive ? '1fr' : 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: responsive ? '15px' : '20px',
          textAlign: 'center',
          color: '#2f5d32'
        }}>
          {[
            { icon: <FaRegClock size={responsive ? 30 : 40} color="#ff6b35" />, title: 'Search & Clearance' },
            { icon: <FaFileContract size={responsive ? 30 : 40} color="#ff6b35" />, title: 'Power of Attorney' },
            { icon: <FaFileContract size={responsive ? 30 : 40} color="#ff6b35" />, title: 'Application Filing' },
            { icon: <FaCheckCircle size={responsive ? 30 : 40} color="#ff6b35" />, title: 'Examination & Publication' },
            { icon: <FaShieldAlt size={responsive ? 30 : 40} color="#ff6b35" />, title: 'Registration & Certificate' }
          ].map(({ icon, title }, i) => (
            <div key={i} style={{
              padding: responsive ? '15px 10px' : '25px',
              border: '2px solid #ff6b35',
              borderRadius: '12px',
              backgroundColor: '#f9f9f9'
            }}>
              <div style={{ marginBottom: '10px' }}>{icon}</div>
              <h3 style={{
                fontSize: fontSize('18px', '13px'),
                marginTop: '10px',
                margin: '10px 0 0 0'
              }}>{title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Foreign Applicant */}
      <section style={{
        padding: responsive ? '20px 15px' : '50px 40px',
        maxWidth: '100%',
        margin: 'auto',
        overflow: 'hidden'
      }}>
        <h2 style={{
          fontSize: fontSize('28px', '18px'),
          color: '#2f5d32',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          For Foreign Applicants
        </h2>
        <p style={{
          fontSize: fontSize('16px', '13px'),
          lineHeight: 1.6,
          padding: responsive ? '0 5px' : '0'
        }}>
          Foreign companies and individuals can apply through a local agent using a Power of Attorney. JK Associates specializes in assisting foreign applicants with the legal formalities for hassle-free trademark registration.
        </p>
      </section>

      {/* Timeline & Fees */}
      <section style={{
        backgroundColor: 'white',
        padding: responsive ? '18px 12px' : '48px 40px',
        maxWidth: '100%',
        margin: 'auto',
        marginTop: responsive ? '18px' : '40px',
        marginBottom: responsive ? '18px' : '40px',
        borderRadius: '14px',
        border: '1px solid rgba(255,107,53,0.12)',
        overflow: 'hidden',
        boxShadow: '0 6px 30px rgba(46,125,50,0.04)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
          flexDirection: responsive ? 'column' : 'row',
          marginBottom: responsive ? '18px' : '28px'
        }}>
          <div style={{ textAlign: responsive ? 'center' : 'left', flex: 1 }}>
            <h2 style={{
              fontSize: fontSize('28px', '18px'),
              color: '#e55a28',
              margin: 0,
              fontWeight: 700
            }}>Timeline & Fees</h2>
            <p style={{
              fontSize: fontSize('14px', '13px'),
              color: '#556b2f',
              marginTop: '8px',
              maxWidth: responsive ? '100%' : '720px',
              opacity: 0.95
            }}>
              Clear, transparent pricing and realistic timelines. We guide you through each step and handle formalities so you can focus on your brand.
            </p>
          </div>

          <div style={{
            display: 'inline-flex',
            gap: '12px',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, rgba(255,107,53,0.12), rgba(255,107,53,0.06))',
              color: '#e55a28',
              padding: '10px 14px',
              borderRadius: '999px',
              fontWeight: 700,
              fontSize: fontSize('16px', '14px'),
              border: '1px solid rgba(255,107,53,0.08)'
            }}>
              Free Consultation
            </div>
            <div style={{
              background: 'white',
              color: '#c04343ff',
              padding: '10px 14px',
              borderRadius: '999px',
              fontWeight: 700,
              fontSize: fontSize('16px', '14px'),
              border: '1px dashed rgba(175, 76, 76, 0.12)'
            }}>
              No Hidden Charges
            </div>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
          gap: responsive ? '16px' : '22px',
          alignItems: 'stretch'
        }}>
          {[
            {
              icon: <FaRegClock size={responsive ? 28 : 36} color="#ff6b35" />,
              title: 'Timeline',
              value: 'Approx. 12–18 months',
              note: 'From filing to registration (subject to government processing & oppositions).'
            },
            {
              icon: <FaFileContract size={responsive ? 28 : 36} color="#ff6b35" />,
              title: 'Government Fees',
              value: 'Starts from BDT 6,000',
              note: 'Fees vary by class & application type. Exact estimate provided after review.'
            },
            {
              icon: <FaShieldAlt size={responsive ? 28 : 36} color="#ff6b35" />,
              title: 'Professional Fees',
              value: 'Competitive & tailored',
              note: 'Transparent, no-surprise billing. Payment plans available for eligible clients.'
            }
          ].map((item, i) => (
            <div key={i} style={{
              background: 'linear-gradient(180deg, #ffffff, #fbfff9)',
              borderRadius: '12px',
              padding: responsive ? '14px' : '20px',
              border: '1px solid rgba(255,107,53,0.08)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              boxShadow: '0 6px 18px rgba(255,107,53,0.04)',
              transition: 'transform 160ms ease, box-shadow 160ms ease',
              cursor: 'default'
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 18px 40px rgba(255,107,53,0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 18px rgba(255,107,53,0.04)';
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{
                  width: responsive ? '48px' : '60px',
                  height: responsive ? '48px' : '60px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, rgba(255,107,53,0.08), rgba(255,107,53,0.02))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  {item.icon}
                </div>
                <div style={{ textAlign: 'left' }}>
                  <h3 style={{
                    fontSize: fontSize('18px', '15px'),
                    margin: 0,
                    color: '#e55a28',
                    fontWeight: 700
                  }}>{item.title}</h3>
                  <div style={{ marginTop: '6px', display: 'flex', gap: '8px', alignItems: 'baseline' }}>
                    <strong style={{ fontSize: fontSize('20px', '16px'), color: '#e55a28' }}>{item.value}</strong>
                  </div>
                </div>
              </div>

              <p style={{
                marginTop: '12px',
                marginBottom: 0,
                color: '#56764d',
                fontSize: fontSize('14px', '12px'),
                lineHeight: 1.5
              }}>{item.note}</p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: responsive ? '14px' : '22px',
          textAlign: 'center'
        }}>
          <button
            onClick={() => window.open('https://api.whatsapp.com/send/?phone=01511404971&text=I%20am%20interested%20in%20Trademark%20Registration%20services%20in%20Bangladeshs', '_self')}
            style={{
              backgroundColor: '#ff6b35',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              padding: responsive ? '10px 20px' : '12px 28px',
              fontSize: fontSize('16px', '14px'),
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 10px 28px rgba(255,107,53,0.14)',
              transition: 'transform 150ms ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Get a Detailed Quote
          </button>
        </div>
      </section>


      {/* Counterfeit Investigation Service */}
      <section style={{
        backgroundColor: 'white',
        padding: responsive ? '20px 15px' : '60px 40px',
        maxWidth: '100%',
        margin: 'auto',
        marginTop: responsive ? '20px' : '40px',
        overflow: 'hidden'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'flex',
            flexDirection: responsive ? 'column' : 'row',
            alignItems: 'center',
            gap: responsive ? '20px' : '50px',
            marginBottom: responsive ? '30px' : '50px'
          }}>
            <div style={{ flex: 1 }}>
              <span style={{
                color: '#ff6b35',
                fontSize: fontSize('16px', '13px'),
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>🔍 Counterfeit Investigation</span>
              <h2 style={{
                fontSize: fontSize('36px', '22px'),
                color: '#2f5d32',
                marginTop: '12px',
                marginBottom: '20px',
                fontWeight: 700,
                lineHeight: 1.3
              }}>
                Protect Your Brand from Counterfeit Products
              </h2>
              <p style={{
                fontSize: fontSize('16px', '13px'),
                color: '#555',
                lineHeight: 1.7,
                marginBottom: '20px'
              }}>
                Counterfeiting poses a serious threat to your brand reputation and revenue. JK Associates provides comprehensive counterfeit investigation services to identify, document, and take legal action against unauthorized sellers and manufacturers.
              </p>
              <button
                onClick={() => window.open("https://api.whatsapp.com/send/?phone=01511404971&text=I%20am%20interested%20in%20Counterfeit%20Investigation%20services", "_blank")}
                style={{
                  backgroundColor: '#ff6b35',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: responsive ? '10px 20px' : '12px 28px',
                  fontSize: fontSize('15px', '13px'),
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(255,107,53,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Learn More <span style={{ fontSize: '12px' }}>→</span>
              </button>
            </div>

            <div style={{ flex: 1 }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: responsive ? '14px' : '16px'
              }}>
                {[
                  { icon: '🔎', title: 'Market Surveillance', desc: 'Monitor online & offline markets' },
                  { icon: '🔐', title: 'Evidence Collection', desc: 'Professional documentation for legal action' },
                  { icon: '⚖️', title: 'Legal Action', desc: 'Swift enforcement through courts' },
                  { icon: '📊', title: 'Damage Assessment', desc: 'Calculate losses & claim compensation' }
                ].map((item, i) => (
                  <div key={i} style={{
                    backgroundColor: '#f5f5f5',
                    padding: responsive ? '14px 12px' : '16px',
                    borderRadius: '10px',
                    border: '1px solid #e0e0e0',
                    textAlign: 'center',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#e8f5e9';
                      e.currentTarget.style.borderColor = '#ff6b35';
                      e.currentTarget.style.transform = 'translateY(-4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#f5f5f5';
                      e.currentTarget.style.borderColor = '#e0e0e0';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}>
                    <div style={{ fontSize: responsive ? '28px' : '32px', marginBottom: '8px' }}>{item.icon}</div>
                    <h4 style={{ fontSize: fontSize('14px', '12px'), fontWeight: 700, margin: '8px 0', color: '#2f5d32' }}>{item.title}</h4>
                    <p style={{ fontSize: fontSize('12px', '11px'), color: '#666', margin: 0, lineHeight: 1.4 }}>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* How It Works */}
          <div style={{
            backgroundColor: '#f9f9f9',
            padding: responsive ? '20px 15px' : '30px',
            borderRadius: '12px',
            marginTop: responsive ? '20px' : '30px'
          }}>
            <h3 style={{
              fontSize: fontSize('24px', '16px'),
              color: '#2f5d32',
              marginBottom: '24px',
              textAlign: 'center',
              fontWeight: 700
            }}>How We Provide Counterfeit Investigation Services</h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: responsive ? '1fr' : 'repeat(4, 1fr)',
              gap: responsive ? '16px' : '20px'
            }}>
              {[
                { step: '01', title: 'Initial Assessment', desc: 'Review your brand, products, and markets to identify risk areas' },
                { step: '02', title: 'Market Monitoring', desc: 'Conduct online & offline surveillance on e-commerce, retail & wholesale channels' },
                { step: '03', title: 'Evidence Gathering', desc: 'Document counterfeits with photos, purchases, and authentication details' },
                { step: '04', title: 'Legal Enforcement', desc: 'File complaints, seek court orders, customs seizure, and compensation' }
              ].map((item, i) => (
                <div key={i} style={{
                  background: 'white',
                  padding: responsive ? '14px' : '18px',
                  borderRadius: '10px',
                  border: '2px solid #e8f5e9',
                  textAlign: 'center',
                  transition: 'all 0.3s',
                  position: 'relative'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#ff6b35';
                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(255,107,53,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e8f5e9';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: responsive ? '36px' : '44px',
                    height: responsive ? '36px' : '44px',
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    borderRadius: '50%',
                    fontWeight: 700,
                    fontSize: fontSize('16px', '14px'),
                    marginBottom: '12px'
                  }}>
                    {item.step}
                  </div>
                  <h4 style={{
                    fontSize: fontSize('16px', '13px'),
                    color: '#2f5d32',
                    fontWeight: 700,
                    margin: '12px 0',
                    minHeight: '40px'
                  }}>{item.title}</h4>
                  <p style={{
                    fontSize: fontSize('13px', '11px'),
                    color: '#666',
                    lineHeight: 1.5,
                    margin: 0
                  }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Industrial Design Protection */}
      <section style={{
        backgroundColor: '#f9f9f9',
        padding: responsive ? '20px 15px' : '60px 40px',
        maxWidth: '100%',
        margin: 'auto',
        marginTop: responsive ? '20px' : '40px',
        overflow: 'hidden'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: responsive ? '30px' : '50px' }}>
            <span style={{
              color: '#ff6b35',
              fontSize: fontSize('16px', '13px'),
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>🎨 Industrial Design Protection</span>
            <h2 style={{
              fontSize: fontSize('36px', '22px'),
              color: '#2f5d32',
              marginTop: '12px',
              marginBottom: '15px',
              fontWeight: 700,
              lineHeight: 1.3
            }}>
              Protect the Unique Look of Your Products
            </h2>
            <p style={{
              fontSize: fontSize('16px', '13px'),
              color: '#555',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: 1.7
            }}>
              Industrial design protects the aesthetic and ornamental aspects of your product. Register your design to prevent competitors from copying your unique appearance and form.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
            gap: responsive ? '18px' : '24px'
          }}>
            {[
              { emoji: '🎯', title: 'What We Protect', desc: 'Shape, form, color patterns, ornaments, and surface textures of your product.' },
              { emoji: '⏱️', title: 'Duration', desc: 'Design protection typically lasts 5-10 years from registration date.' },
              { emoji: '🏆', title: 'Competitive Edge', desc: 'Exclusive rights to manufacture, sell, and import your unique design.' }
            ].map((item, i) => (
              <div key={i} style={{
                backgroundColor: 'white',
                padding: responsive ? '18px' : '24px',
                borderRadius: '12px',
                border: '1px solid #e0e0e0',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                transition: 'all 0.3s'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(255,107,53,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
                }}>
                <div style={{ fontSize: responsive ? '36px' : '44px', marginBottom: '16px' }}>{item.emoji}</div>
                <h3 style={{
                  fontSize: fontSize('18px', '15px'),
                  color: '#2f5d32',
                  fontWeight: 700,
                  marginBottom: '12px',
                  minHeight: '50px'
                }}>
                  {item.title}
                </h3>
                <p style={{
                  fontSize: fontSize('14px', '12px'),
                  color: '#666',
                  lineHeight: 1.6,
                  margin: 0
                }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Registration Process */}
          <div style={{
            backgroundColor: 'white',
            padding: responsive ? '20px 15px' : '30px',
            borderRadius: '12px',
            marginTop: responsive ? '20px' : '40px',
            border: '2px solid #ff6b35'
          }}>
            <h3 style={{
              fontSize: fontSize('24px', '16px'),
              color: '#ff6b35',
              marginBottom: '24px',
              textAlign: 'center',
              fontWeight: 700
            }}>Industrial Design Registration Process</h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
              gap: responsive ? '14px' : '20px'
            }}>
              {[
                { title: 'Drawings & Photographs', desc: 'Submit clear, high-quality images showing all angles of your design' },
                { title: 'Description & Classification', desc: 'Describe unique features and classify product category per international standards' },
                { title: 'Registration & Certificate', desc: 'Upon approval, receive design registration certificate with exclusive rights' }
              ].map((item, i) => (
                <div key={i} style={{
                  padding: responsive ? '14px' : '18px',
                  backgroundColor: '#f9f9f9',
                  borderRadius: '10px',
                  border: '1px solid #e8f5e9',
                  textAlign: 'center'
                }}>
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: responsive ? '32px' : '40px',
                    height: responsive ? '32px' : '40px',
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    borderRadius: '50%',
                    fontWeight: 700,
                    fontSize: fontSize('14px', '12px'),
                    marginBottom: '10px'
                  }}>
                    {i + 1}
                  </div>
                  <h4 style={{
                    fontSize: fontSize('15px', '13px'),
                    color: '#2f5d32',
                    fontWeight: 700,
                    margin: '10px 0'
                  }}>{item.title}</h4>
                  <p style={{
                    fontSize: fontSize('12px', '11px'),
                    color: '#666',
                    lineHeight: 1.5,
                    margin: 0
                  }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* IPR Enforcement & Litigation */}
      <section style={{
        backgroundColor: 'white',
        padding: responsive ? '20px 15px' : '60px 40px',
        maxWidth: '100%',
        margin: 'auto',
        marginTop: responsive ? '20px' : '40px',
        overflow: 'hidden'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: responsive ? '30px' : '50px' }}>
            <span style={{
              color: '#ff6b35',
              fontSize: fontSize('16px', '13px'),
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>⚖️ IPR Enforcement & Litigation</span>
            <h2 style={{
              fontSize: fontSize('36px', '22px'),
              color: '#2f5d32',
              marginTop: '12px',
              marginBottom: '15px',
              fontWeight: 700,
              lineHeight: 1.3
            }}>
              Aggressive Protection Against IPR Violations
            </h2>
            <p style={{
              fontSize: fontSize('16px', '13px'),
              color: '#555',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: 1.7
            }}>
              Your intellectual property deserves strong legal defense. JK Associates handles enforcement actions, litigation, and settlement negotiations to protect your rights.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : 'repeat(2, 1fr)',
            gap: responsive ? '20px' : '30px'
          }}>
            {[
              {
                title: '⚖️ Civil Litigation',
                items: [
                  'Filing infringement suits in courts',
                  'Seeking injunctions & damages',
                  'Managing disputes with competitors',
                  'Negotiating settlements & licensing'
                ]
              },
              {
                title: '📋 Administrative Actions',
                items: [
                  'Opposition proceedings at DPDT',
                  'Cancellation requests for invalid marks',
                  'Counter-claims & defense strategies',
                  'Appellate proceedings & reviews'
                ]
              },
              {
                title: '🚫 Customs & Border Protection',
                items: [
                  'Record your mark with customs authorities',
                  'Stop counterfeit goods at borders',
                  'Seize infringing merchandise',
                  'Criminal referrals & prosecution'
                ]
              },
              {
                title: '🌐 Online Enforcement',
                items: [
                  'DMCA takedown notices',
                  'Domain name dispute resolution (ICANN)',
                  'Marketplace & social media removal',
                  'E-commerce platform enforcement'
                ]
              }
            ].map((section, i) => (
              <div key={i} style={{
                backgroundColor: '#f9f9f9',
                padding: responsive ? '18px' : '24px',
                borderRadius: '12px',
                border: '2px solid #e8f5e9',
                transition: 'all 0.3s'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#ff6b35';
                  e.currentTarget.style.backgroundColor = '#f0f8f0';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e8f5e9';
                  e.currentTarget.style.backgroundColor = '#f9f9f9';
                }}>
                <h3 style={{
                  fontSize: fontSize('18px', '15px'),
                  color: '#ff6b35',
                  fontWeight: 700,
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  {section.title}
                </h3>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0
                }}>
                  {section.items.map((item, idx) => (
                    <li key={idx} style={{
                      fontSize: fontSize('14px', '12px'),
                      color: '#555',
                      marginBottom: responsive ? '8px' : '10px',
                      paddingLeft: '24px',
                      position: 'relative',
                      lineHeight: 1.5
                    }}>
                      <span style={{
                        position: 'absolute',
                        left: 0,
                        color: '#ff6b35',
                        fontWeight: 'bold'
                      }}>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* CTA for Enforcement */}
          <div style={{
            backgroundColor: 'linear-gradient(135deg, #ff6b35, #e55a28)',
            backgroundImage: 'linear-gradient(135deg, #ff6b35, #e55a28)',
            padding: responsive ? '20px 15px' : '40px',
            borderRadius: '12px',
            textAlign: 'center',
            marginTop: responsive ? '20px' : '40px',
            color: 'white'
          }}>
            <h3 style={{
              fontSize: fontSize('22px', '16px'),
              fontWeight: 700,
              marginBottom: '12px'
            }}>
              Found Your IP Being Infringed?
            </h3>
            <p style={{
              fontSize: fontSize('14px', '12px'),
              margin: '0 0 16px 0',
              opacity: 0.95
            }}>
              Act now before further damage. Our legal team will evaluate your case and recommend immediate enforcement strategies.
            </p>
            <button
              onClick={() => window.open("https://api.whatsapp.com/send/?phone=01511404971&text=I%20need%20IP%20Enforcement%20assistance", "_blank")}
              style={{
                backgroundColor: 'white',
                color: '#ff6b35',
                border: 'none',
                borderRadius: '8px',
                padding: responsive ? '10px 20px' : '12px 28px',
                fontSize: fontSize('15px', '13px'),
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              Get Emergency Legal Help
            </button>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section style={{
        backgroundImage: 'linear-gradient(135deg, #ff6b35, #e55a28)',
        padding: responsive ? '20px 15px' : '60px 40px',
        color: 'white',
        textAlign: 'center',
        marginTop: responsive ? '20px' : '40px',
        overflow: 'hidden'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: fontSize('36px', '22px'),
            marginBottom: '16px',
            fontWeight: 700
          }}>
            Ready to Protect Your Intellectual Property?
          </h2>
          <p style={{
            fontSize: fontSize('16px', '13px'),
            marginBottom: '30px',
            opacity: 0.95,
            lineHeight: 1.6
          }}>
            Let JK Associates be your trusted partner in securing and enforcing your IP rights. Get a free consultation today.
          </p>
          <div style={{
            display: 'flex',
            gap: responsive ? '10px' : '16px',
            flexDirection: responsive ? 'column' : 'row',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => window.open("https://api.whatsapp.com/send/?phone=01511404971&text=I%20would%20like%20to%20schedule%20a%20free%20consultation", "_blank")}
              style={{
                backgroundColor: 'white',
                color: '#ff6b35',
                border: 'none',
                borderRadius: '8px',
                padding: responsive ? '12px 24px' : '14px 32px',
                fontSize: fontSize('16px', '13px'),
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 28px rgba(0,0,0,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
              }}
            >
              Free Consultation
            </button>
            <button
              onClick={() => window.open("tel:+8801511404971")}
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: '2px solid white',
                borderRadius: '8px',
                padding: responsive ? '10px 22px' : '12px 30px',
                fontSize: fontSize('16px', '13px'),
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = '#ff6b35';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'white';
              }}
            >
              Call Us Now
            </button>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{
        padding: responsive ? '20px 15px' : '50px 40px',
        maxWidth: '100%',
        margin: 'auto',
        overflow: 'hidden'
      }}>
        <h2 style={{
          fontSize: fontSize('32px', '18px'),
          marginBottom: '30px',
          color: '#ff6b35',
          textAlign: 'center'
        }}>
          Frequently Asked Questions
        </h2>
        <Faq items={faqItems} />
      </section>

      {/* Testimonials */}
      <section style={{
        backgroundColor: 'white',
        padding: responsive ? '20px 15px' : '60px 40px',
        color: '#ff6b35',
        border: '2px solid #ff6b35',
        borderRadius: '12px',
        marginTop: responsive ? '20px' : '40px',
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Decorative background elements */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.05,
          pointerEvents: 'none',
          backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>

        <div style={{ position: 'relative', zIndex: 1 }}>
          {/* Header Section */}
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: '15px'
            }}>
              <div style={{ width: '40px', height: '2px', backgroundColor: 'white' }}></div>
              <span style={{
                fontSize: fontSize('16px', '12px'),
                fontWeight: '600',
                letterSpacing: '2px',
                textTransform: 'uppercase'
              }}>Client Testimonials</span>
              <div style={{ width: '40px', height: '2px', backgroundColor: 'white' }}></div>
            </div>

            <h2 style={{
              fontSize: fontSize('40px', '24px'),
              marginBottom: '15px',
              fontWeight: '700',
              lineHeight: 1.3
            }}>
              What Our Clients Say
            </h2>

            <p style={{
              fontSize: fontSize('16px', '13px'),
              maxWidth: '600px',
              margin: '0 auto',
              opacity: 0.95,
              lineHeight: 1.6
            }}>
              Join hundreds of satisfied clients who have successfully protected their brands with JK Associates
            </p>
          </div>

          {/* Testimonials Container */}
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            <Testimonial isResponsive={responsive} whiteTheme />
          </div>

          {/* Stats Section Below Testimonials */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
            gap: responsive ? '20px' : '40px',
            marginTop: responsive ? '40px' : '60px',
            paddingTop: responsive ? '30px' : '40px',
            borderTop: '1px solid rgba(255,255,255,0.2)'
          }}>
            {[
              { number: '500+', label: 'Successful Registrations' },
              { number: '98%', label: 'Client Satisfaction Rate' },
              { number: '15+', label: 'Years of Experience' }
            ].map((stat, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <h3 style={{
                  fontSize: fontSize('32px', '20px'),
                  fontWeight: '700',
                  margin: '0 0 8px 0',
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                  {stat.number}
                </h3>
                <p style={{
                  fontSize: fontSize('14px', '12px'),
                  margin: 0,
                  opacity: 0.9,
                  fontWeight: '500'
                }}>
                  {stat.label}
                </p>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div style={{
            textAlign: 'center',
            marginTop: responsive ? '30px' : '50px'
          }}>
            <button
              onClick={() => window.open("https://www.google.com/maps/place/JK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark/@23.7927683,90.3719291,17z/data=!4m16!1m9!3m8!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!2sJK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark!8m2!3d23.7927683!4d90.374504!9m1!1b1!16s%2Fg%2F11c54h2yxw!3m5!1s0x3755b8bf5300eaad:0xe50b10a249f6394e!8m2!3d23.7927683!4d90.374504!16s%2Fg%2F11c54h2yxw?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D")}
              style={{
                backgroundColor: 'white',
                color: '#ff6b35',
                border: 'none',
                borderRadius: '8px',
                padding: responsive ? '12px 32px' : '16px 48px',
                fontSize: fontSize('16px', '13px'),
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                letterSpacing: '0.5px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
              }}
            >
              Share Your Trademark Journey With Us
            </button>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section style={{
        textAlign: 'center',
        padding: responsive ? '20px 15px' : '60px 40px',
        overflow: 'hidden'
      }}>
        <button
          onClick={() => window.open("https://api.whatsapp.com/send/?phone=01511404971&text=I%20am%20interested%20in%20Trademark%20Registration%20services%20in%20Bangladesh", "_blank")}
          style={{
            backgroundColor: '#ff6b35',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: responsive ? '12px 24px' : '18px 40px',
            fontSize: fontSize('18px', '14px'),
            cursor: 'pointer',
            boxShadow: '0 5px 15px rgba(255,107,53,0.4)',
            fontWeight: '600',
            transition: 'all 0.3s',
            minWidth: responsive ? '100%' : 'auto'
          }}
        >
          Get Started Now
        </button>
      </section>
    </main>
  );
}